import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import {Funcoes} from "../funcoes";
import {Global} from "../global";
import {MercadoriasService} from "../mercadorias/mercadorias.service";
import {MercadoriasEmbalagensModel} from "./mercadorias-embalagens.model";
import {MercadoriasEmbalagensService} from "./mercadorias-embalagens.service";


@Component({
  selector: 'app-mercadorias-embalagens-form',
  templateUrl: './mercadorias-embalagens-form.component.html'
})
export class MercadoriasEmbalagensFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  embalagem: MercadoriasEmbalagensModel = new MercadoriasEmbalagensModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;
  listMercadorias = [];

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private mercadoriasEmbalagensService: MercadoriasEmbalagensService,
    private mercadoriasService: MercadoriasService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id_embalagem: [],
      nome_pt: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      nome_en: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      nome_es: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]]
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    this.mercadoriasService.get()
      .subscribe(
        json => {
          this.listMercadorias = json.Payload;

          if(this.global.debug == true){
            console.log(json.Payload);
          }
        },
        error => {
          this.func.showErro(error.json());
        });

    this.route.params.subscribe(params => {
      let id = params['id_embalagem'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarEmbalagem');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarEmbalagem') : this.func.traduzir('front.cadastrarNovaEmbalagem');
      }

      if (!id) {
        return;
      }

      this.mercadoriasEmbalagensService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarEmbalagem')+': '+json.Payload[0].nome_pt;
            }else{
              this.title = this.func.traduzir('front.visualizarEmbalagem') + ': ' + json.Payload[0].nome_pt;
            }
            this.embalagem = json.Payload[0];

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    let result,

    values = this.form.value;

    if (values.id_embalagem) {
      result = this.mercadoriasEmbalagensService.editar(values, values.id_embalagem);
    } else {
      result = this.mercadoriasEmbalagensService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'mercadorias', 'embalagens']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/mercadorias-embalagens/mercadorias-embalagens-form.component.ts